export default function getTimeDiffInDays(date1, date2) {
    const diff = date1 - date2

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    return days
}
